import { Draggable } from "react-beautiful-dnd";
import { Box, CircularProgress, Typography } from "@mui/material";
import CoverageDroppable from "./CoverageDroppable";
import SimpleAccordin from "../../../components/SimpleAccordin";

const SystemChoiceDraggable = ({ systemChoice, questionCitations, coverageDndType, coverageChoice, inspection, index, expanded, onAccordionChange, citationsLoading }) => {
  const questionCitationsPerSystemChoice = questionCitations?.filter(
    p => p.detail?.systemChoice === systemChoice?.code_table_uid &&
    p.detail?.coverageChoice === coverageChoice);

  const hasContent = questionCitationsPerSystemChoice?.length > 0;

  if (!citationsLoading && !hasContent) return (
    <Draggable draggableId={systemChoice?.code_table_uid} index={index}>
      {(provided) => (
        <Box {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} />
      )}
    </Draggable>
  );

  return (
    <Draggable draggableId={systemChoice?.code_table_uid} index={index}>
      {(provided) => (
        <Box {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
          <SimpleAccordin
            title={systemChoice?.description}
            isDragNDrop
            expanded={expanded}
            onChange={onAccordionChange(systemChoice?.code_table_uid)}
          >
            {citationsLoading && !hasContent ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 2 }}>
                <CircularProgress size={16} />
                <Typography variant="body2">Loading...</Typography>
              </Box>
            ) : (
              <CoverageDroppable
                systemChoice={systemChoice}
                questionCitationsPerSystemChoice={questionCitationsPerSystemChoice}
                coverageDndType={coverageDndType}
                coverageChoice={coverageChoice}
                inspection={inspection}
              />
            )}
          </SimpleAccordin>
        </Box>
      )}
    </Draggable>
  );
};

export default SystemChoiceDraggable;
